<!--
 * @Description:  封装table
 * @Author: miaofenfen
 * @Date: 2021-04-09 18:00:00
 * @LastEditors: miaofenfen
 * @LastEditTime:2021-04-09 18:00:00
 -->
<template>
	<div>
		<el-table
			ref="table"
			style="width: 100%"
			border
			:data="tableData"
			v-loading="loading"
			@selection-change="handleSelectionChange"
			highlight-current-row
			:row-key="rowKey"
			:row-class-name="rowClassName"
			:span-method="spanMethod"
			:cell-class-name="cellClassName"
			:height="height"
		>
			<el-table-column type="selection" width="55" align="center" v-if="!selectionHide" />
			<template v-for="(col, index) in columns">
				<slot v-if="col.slot" :name="col.slot" :fixed="col.fixed" />
				<el-table-column
					v-else
					:key="index"
					:prop="col.prop"
					:label="col.label"
					:width="col.width"
					:formatter="col.formatter"
					:align="col.align"
					:show-overflow-tooltip="col.showTooltip"
					:fixed="col.fixed"
				/>
			</template>
		</el-table>
	</div>
</template>
<script>
export default {
	name: 'dataTable',
	props: {
		rowClassName: {
			type: Function,
			default: function() {}
		},
		cellClassName: {
			type: Function,
			default: function() {}
		},
		loading: {
			type: Boolean
		},
		tableData: {
			type: Array,
			default: () => []
		},
		columns: {
			type: Array
		},
		selectionHide: {
			type: Boolean
		},
		selectList: {
			type: Array,
			default: () => []
		},
		rowKey: {
			type: Function
		},
		spanMethod: {
			type: Function
		},
		height: {
			type: Number
		}
	},
	watch: {
		tableData: {
			handler(newVal, oldVal) {
				this.$nextTick(function() {
					if (this.selectList != undefined && this.selectList.length >= 1) {
						//过滤相同的值
						let sameArr = this.tableData.filter(item => this.selectList.some(ele => ele.id === item.id));
						//默认选中哪一行
						sameArr.forEach(item => {
							this.$refs.table.toggleRowSelection(item, true);
						});
					}
				});
			},
			// 代表在wacth里声明了tableData这个方法之后立即先去执行handler方法
			immediate: true
		},
		selectList: {
			handler(newVal, oldVal) {
				if (!newVal.length) {
					this.$nextTick(function() {
						this.tableData.forEach(item => {
							this.$refs.table.toggleRowSelection(item, false);
						});
					});
				} else {
					this.$nextTick(function() {
						if (this.selectList != undefined && this.selectList.length >= 1) {
							//过滤相同的值
							let sameArr = this.tableData.filter(item => this.selectList.some(ele => ele.id === item.id));
							//默认选中哪一行
							sameArr.forEach(item => {
								this.$refs.table.toggleRowSelection(item, true);
							});
						}
					});
				}
			},
			immediate: true
		}
	},
	// mounted() {},
	methods: {
		//多选
		handleSelectionChange(selection) {
			// console.log("多选", selection);
			this.$emit('handleSelectionChange', selection);
			// this.ids = selection.map(item => item.noticeId);
			// this.single = selection.length != 1;
			// this.multiple = !selection.length;
		}
		//单选--先注释
		// handleCurrentChange(val) {
		//   // this.currentRow = val;
		//   // console.log("单选", val);
		//   this.$emit("handleSelectionChange", [val]);
		// }
	}
};
</script>
<style>
.el-table .warning-row {
	background: oldlace;
}
.el-table .warning-row1 {
	background: #f15a22;
}
.el-table .error-row {
	background: red;
}

.el-table .success-row {
	background: #f0f9eb;
}
.el-table .green-row {
	background: #13ce66;
}
.el-table .warning-row3 {
	background: #ffba00;
}
/* .el-table tbody tr:hover > td {
  background: none;
} */
</style>
